import { signOutRequest } from "@/store/auth/authSlice";
import { IoNotificationsOutline } from "react-icons/io5";
import { LuChevronsUpDown } from "react-icons/lu";
import { TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PopperComponent from "../Core/PopperComponent";
import ImageDetailsComponent from "../ImageDetailsComponent";
import ThemeSwitcher from "../ThemeSwitcher";
import Classes from "./AfterLoginHeader.module.css";

export const AfterLoginHeader = ({ drawerBtn, setIsCollapsed }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.authReducer);
  const { unReadNotificationCount } = useSelector(
    (state) => state.commonReducer
  );
  const navigate = useNavigate();

  const handleClick = (item) => {
    switch (item?.value) {
      case "settings":
        navigate("/settings");
        break;
      case "logout":
        dispatch(signOutRequest());
        navigate("/login");
        break;
    }
  };
  return (
    <div className={Classes.navbarContainer}>
      {drawerBtn && drawerBtn}
      <div className={Classes.mainHeader}>
        <TbLayoutSidebarLeftCollapse
          onClick={() => setIsCollapsed((prev) => !prev)}
        />
      </div>
      <ThemeSwitcher />
      <div
        className={Classes.notification_header}
        onClick={() => navigate("/notifications")}
      >
        {unReadNotificationCount > 0 && (
          <p>{unReadNotificationCount > 9 ? "9+" : unReadNotificationCount}</p>
        )}
        <IoNotificationsOutline />
      </div>
      <PopperComponent
        data={[
          { label: "Settings", value: "settings" },
          { label: "Logout", value: "logout" },
        ]}
        handleClick={handleClick}
        width="auto"
        children={
          <div className={Classes.profileImg}>
            <ImageDetailsComponent user={user} size="sm" />
            <LuChevronsUpDown color="#999999" />
          </div>
        }
      />
    </div>
  );
};
